import isPlainObject from './isPlainObject';
import * as Tools from "../../../../helpers/Tools";
import { logUI } from "../../../../api/andyliticsApi";
import { CONSUMER } from '../constants';
import Video from 'twilio-video';

export const isMobile = (() => {
    if (typeof navigator === 'undefined' || typeof navigator.userAgent !== 'string') {
        return false;
    }
    return /Mobile/.test(navigator.userAgent);
})();

export function Logger(activityCode, startTime, activityJsonData = null, activityParam1 = null, activityParam2 = null) {
    try {
        let actCode = window.twilioSource && window.twilioSource.toUpperCase() === CONSUMER ? "MBHWeb." + activityCode : activityCode;
        let twilioRoomName = window.twilioRoom && window.twilioRoom.name ? window.twilioRoom.name : null;
        logUI(actCode, startTime ? startTime : new Date(), Tools.getURLPath(), activityJsonData, activityParam1 ? activityParam1 : twilioRoomName, activityParam2)
    } catch (e) {
        console.log(e);
        logUI("Twilio.Web.Log.Failure", new Date(), null, e);
    }
}

export function saveTwilioLogs(args, customLevelToStore, roomName) {
    let logLevelToStore = customLevelToStore ? customLevelToStore.toLowerCase() : "off";
    if (typeof args !== 'object' || logLevelToStore === 'off') return;
    const log = Array.prototype.slice.call(args);
    const [dateTime, logLevel, component, message, data] = log;
    const stringifyMessage = message ? JSON.stringify(message) : null;
    //Don't log dom object which will cause circular object error.
    const twilioLogInfo = {
        dateTime, logLevel, component, message: message, data: isDOMObject(data) ? {} : data
    };

    if (logLevelToStore === 'minimal' || logLevelToStore === 'normal') {
        //Normal - debug and info logs expect hearbeat signal.
        if (logLevelToStore === 'normal' && stringifyMessage && stringifyMessage.indexOf("heartbeat") < 0) {
            Logger("Twilio.Server.Log", new Date(), twilioLogInfo, roomName);
        } else if (logLevelToStore === 'minimal' && logLevel === 'info') {
            // Minimal - only info logs.          
            Logger("Twilio.Server.Log", new Date(), twilioLogInfo, roomName);
        }
    } else if (logLevelToStore === 'high') {
        //High - Sending all the twilio logs to kusto. Be aware before enabling this level, we get lot of hearbeat signal event logs per secound. It may impact our performance.
        Logger("Twilio.Server.Log", new Date(), twilioLogInfo, roomName);
    }
    // console.log(twilioLogInfo);
}

function isDOMObject(obj) {
    try {
        if (!obj) return false;
        if (obj instanceof Element) return true;
        if (Array.isArray(obj)) {
            for (const elem of obj) {
                if (elem instanceof Element) return true;
            }
        }
    } catch (e) {
        console.log(e);
    }
    return false;
}

export function endCall() {
    const currentRoom = window.twilioRoom;  //room reference
    //Removing reference of logging how twilio does.
    if (Video && Video.Logger) {
        const loggers = Video.Logger.getLoggers();
        Object.keys(loggers).forEach(name => {
            delete loggers[name];
            localStorage.removeItem('loglevel:' + name);
        });
    }
    if (currentRoom && currentRoom.localParticipant.state === 'connected') {
        currentRoom.localParticipant.tracks.forEach(function (trackPublication) {
            if (trackPublication.track.stop)
                trackPublication.track.stop();
            if (trackPublication.track.detach)
                trackPublication.track.detach().forEach(element => element.remove());
            currentRoom.localParticipant.unpublishTrack(trackPublication.track);
        });
        currentRoom.disconnect();
        removeLocalTracks();
        window.localTracks = null;
        window.twilioRoom = null;
        Logger("UI.Twilio.Room.CallCompleted", new Date());
        return null;
    } else {
        removeLocalTracks();
    }
}

function removeLocalTracks() {
    if (window.localTracks && window.localTracks.length > 0) {
        Logger("UI.Twilio.Room.RemoveLocalTracks", new Date(), window.localTracks);
        window.localTracks.forEach(track => {
            console.log(track);
            if (track && typeof track.stop === 'function') {
                track.stop();
            }
        });
        window.localTracks = null;
    }
}

export function removeUndefineds(obj) {
    if (!isPlainObject(obj)) return obj;
    const target = {};

    for (const key in obj) {
        const val = obj[key];
        if (typeof val !== 'undefined') {
            target[key] = removeUndefineds(val);
        }
    }

    return target;
}
function browserDetection() {
    if (typeof navigator !== 'undefined' && navigator && navigator.userAgent) {
        if (/Edge\/\d./i.test(navigator.userAgent)) {
            return "Edge";
        } else if (/MSIE|Trident/i.test(navigator.userAgent)) {
            return "IE";
        } else if (navigator.userAgent.indexOf("Firefox") > -1) {
            return 'Firefox';
        } else if (navigator.userAgent.indexOf("CriOS") > -1) { //Mobile IOS Chrome
            return 'Chrome'
        } else if (navigator.userAgent.indexOf("FxiOS") > -1) { //Mobile IOS Firefox
            return 'Firefox';
        } else if (navigator.userAgent.indexOf("edg") > -1) {
            return 'New Edge';
        } else if ((navigator.userAgent.indexOf("Opera") > -1) || (navigator.userAgent.indexOf("OPR") > -1)) {
            return 'Opera';
        } else if (navigator.userAgent.indexOf("SamsungBrowser") > -1) {
            return 'Samsung Internet';
        } else if ((navigator.userAgent.indexOf('Mozilla/5.0') > -1 && navigator.userAgent.indexOf('Android ') > -1 &&
            navigator.userAgent.indexOf('AppleWebKit') > -1) && (navigator.userAgent.indexOf('Version') > -1)) {
            return 'Android Native'; //Mobile Android default browser
        } else if (!(navigator.userAgent.indexOf("Chrome") > -1) && (navigator.userAgent.indexOf("Safari") > -1)) {
            return 'Safari';
        } else if (navigator.userAgent.indexOf("Chrome") > -1 && navigator.vendor && /Google Inc/.test(navigator.vendor)) {
            return 'Chrome';
        }
    }
    return '';
};

function pickWebKeys(settings) {
    if (!isPlainObject(settings)) return settings;
    const target = {};
    for (const key in settings) {
        if (key.indexOf("__Mobile") === -1) {
            // if setting key is not meant for Mobile then only pick
            var val = settings[key];
            if (typeof val !== "undefined") {
                let newKey = key.replace("__Web", "");
                target[newKey] = pickWebKeys(val);
            }
        }
    }
    return target;
}

function sanitizeBrowserKeys(settings, browserName, allBrowsers) {
    if (!isPlainObject(settings)) return settings;
    const target = {};
    for (const key in settings) {
        if (key.indexOf(browserName) > -1) {
            // browser specific key is present
            const tobeDeletedKey = key.replace(browserName, "");
            delete settings[tobeDeletedKey]; // Needs to be deleted both from settings and target as we may not know the sequence in which the key appears
            delete target[tobeDeletedKey];
        }
        else { // this key is for some other browser , let us delete it.
            allBrowsers.forEach((browser) => {
                if (key.indexOf(browser) > -1) {
                    delete settings[key]; // Needs to be deleted both from settings and target as we may not know the sequence in which the key appears
                    delete target[key];
                }
            });

        }
        var val = settings[key];
        if (typeof val !== "undefined") {
            target[key] = sanitizeBrowserKeys(val, browserName, allBrowsers);
        }
    }

    return target;
}

function removeSuffix(settings, browserName) {
    if (!isPlainObject(settings)) return settings;
    const target = {};
    for (const key in settings) {
        var val = settings[key];
        if (typeof val !== "undefined") {
            let newKey = key.replace(browserName, "");
            target[newKey] = removeSuffix(val, browserName);
        }
    }
    return target;
}

function pickMobileBrowserKeys(settings) {
    if (!isPlainObject(settings)) return settings;
    const target = {};
    const mobileBrowserPattern = "_Mobile"; // _Mobile, _Mobile_Browser - key is something like maxTracks__Web_patternToSearch    
    for (const key in settings) {
        if (key.indexOf(mobileBrowserPattern) > -1) {
            // if setting key is  meant for Web Mobile Browser
            var val = settings[key];
            if (typeof val !== "undefined") {
                let newKey = key.replace(mobileBrowserPattern, "");
                target[newKey] = val;
            }
        }
        else {
            target[key] = pickMobileBrowserKeys(settings[key]);
        }
    }
    return target;
}

export function sanitizeSettings(settings) {
    let webKeys = pickWebKeys(settings);
    const currentBrowserName = browserDetection();
    if (navigator && navigator.userAgent && /Mobile/.test(navigator.userAgent))
        webKeys = pickMobileBrowserKeys(webKeys);

    let browserSuffix = null;
    switch (currentBrowserName) {
        case 'Firefox':
            browserSuffix = "_FF";
            break;
        case 'Chrome':
            browserSuffix = "_Chrome";
            break;
        default:
            browserSuffix = null;
    }
    if (browserSuffix) {
        const browserKeysPicked = sanitizeBrowserKeys(webKeys, browserSuffix, ["_FF", "_Chrome"]);
        return removeSuffix(browserKeysPicked, browserSuffix);
    }
    else
        return webKeys;
};

export function getCallDuration(startDateTime) {
    if (!startDateTime) return null;
    const secondsElapsed = (Date.now() - startDateTime) / 1000;
    const hourMinSec = new Date(secondsElapsed * 1000).toISOString().substr(11, 8);
    return (hourMinSec.substr(0, 2) === "00") ? hourMinSec.substr(3) : hourMinSec;
}